import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import useExportIssueExceptions from '../../../hooks/api/issues/useExportIssueExceptions';
import * as IssuesV2Store from '../../../redux/issuesV2';
import Button from '../../generic/Button/Button';
import { BUTTON_SIZE, BUTTON_TYPE } from '../../generic/Button/button-constants';
import { icons } from '../../generic/Icon/icons';
import type { IssueExceptionsFilter, IssueExceptionSort } from '../../../../shared/issuesV2';

type Props = {
  filters: IssueExceptionsFilter;
  search?: string;
  sortBy?: IssueExceptionSort;
};

const ExportIgnoreRulesButton: VoidFunctionComponent<Props> = ({
  filters,
  search,
  sortBy,
}) => {
  const { exportCsv, isExporting } = useExportIssueExceptions();
  const totalCount = useSelector(IssuesV2Store.selectors.getIssueExceptionsCount);
  const hasNoData = totalCount === 0;

  const handleExport = () => {
    exportCsv({ filters, search, sortBy });
  };

  return (
    <Button
      type={BUTTON_TYPE.SECONDARY}
      size={BUTTON_SIZE.MEDIUM}
      onClick={handleExport}
      isDisabled={isExporting || hasNoData}
      icon={icons.downloadRegular}
    >
      {isExporting ? 'Downloading...' : 'Download Rules'}
    </Button>
  );
};

export default ExportIgnoreRulesButton;
